
namespace GeniuzPOS.Purchase {
    import fld = ListAppCnrtvRow.Fields

    @Serenity.Decorators.registerClass()
    export class ListAppCnrtvGrid extends Serenity.EntityGrid<ListAppCnrtvRow, any> {
        protected getColumnsKey() { return ListAppCnrtvColumns.columnsKey; }
        protected getDialogType() { return ListAppCnrtvDialog; }
        protected getIdProperty() { return ListAppCnrtvRow.idProperty; }
        protected getInsertPermission() { return ListAppCnrtvRow.insertPermission; }
        protected getLocalTextPrefix() { return ListAppCnrtvRow.localTextPrefix; }
        protected getService() { return ListAppCnrtvService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            // let self = this;
            // self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            let filters = super.getQuickFilters();             

            var userId = Q.first(Administration.UserRow.getLookup().items, x => x.Username == Authorization.userDefinition.Username);
             var userapprole = Q.tryFirst(Administration.UserApprovalRoleRow.getLookup().items, x => x.UserId == userId.UserId);


            Q.first(filters, x => x.field == fld.WaitApprove).init = w => {
                (w as Serenity.StringEditor).value = userapprole.ApprGroupCode ?? "";               
            };         

            return filters;
        }
    }
}